module.exports = __webpack_public_path__ + "static/media/delete@2x.b3de036b.png";